import React, { useContext, useEffect, useMemo, useState } from 'react'
import AssessmentDetails from '../../../../Components/MultipleAssessments/AssessmentDetails/AssessmentDetails'
import holySpiritIcon from '../../../../Assets/Images/holy-spirit.svg'
import evangelizationIcon from '../../../../Assets/Images/evangelization.svg'
import leadershipIcon from '../../../../Assets/Images/leadership.svg'
import grow from '../../../../Assets/Images/growpkg.svg'
import down from '../../../../Assets/Images/downpkg2.svg'
import './DashboardMultiAssessmentOverview.scss'
import { useParams } from 'react-router-dom'
import DashboardContext from '../../../../Store/DashboardContext';
import LanguageContext from '../../../../Store/LanguageContext';
import MultipleAssessmentsContext from '../../../../Store/MultipleAssessmentsContext';
import { translate } from '../../../../Components/translate/translate';
import ZeroState from '../../../../Components/MultipleAssessments/ZeroState/ZeroState';
import Page404 from '../../../../Components/Page404/Page404';
import { preventWidow } from '../../../../utils/widowFix';
import { formatLeadingOutOfATeam } from '../../../../utils/helper';

const DashboardMultiAssessmentOverview = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0)
  const [activeAudience, setActiveAudience] = useState('parish')
  const dashboardCtx = useContext(DashboardContext);
  const langCtx = useContext(LanguageContext);
  const multipleAssessmentsCtx = useContext(MultipleAssessmentsContext);
  const { deployments, isLoadingDeploymentInfo, is404Error, parishInsights, isLoadingParishInsights } = multipleAssessmentsCtx || {};

  useEffect(() => {
    if (id) {
      multipleAssessmentsCtx.setAssessmentId(id);
    }
  }, [id, multipleAssessmentsCtx]);

  const handleTranslate = (text, type) => {
    switch (langCtx.language) {
      case "Nederlands": {
        return translate(text, "dashboardCompareDutch", type)
      }
      default: {
        return text;
      }
    }
  }

  useEffect(() => {
    dashboardCtx.setDashboardId(id)
    // getParishInsights(id)
  }, [id])
  const tabData = useMemo(() => {
    const defaultSubCategories = (categoryKey) => {
      if (categoryKey === 'Leadership') {
        return [
          "Vision",
          "Planning and Priorities",
          "Leading out of a team",
          "Growing Leadership Skills"
        ].map(section => ({
          name: handleTranslate(section, section.toLowerCase().replace(/\s+/g, '-')),
          stats: {
            parish: { mw1: 0, mw3: 0, change: 0 },
            leaders: { mw1: 0, mw3: 0, change: 0 },
            parishioners: { mw1: 0, mw3: 0, change: 0 }
          }
        }));
      }

      if (categoryKey === 'Evangelization') {
        return [
          "Resources Aligned",
          "Primacy of Programs",
          "Cultural Reinforcement"
        ].map(section => ({
          name: handleTranslate(section, section.toLowerCase().replace(/\s+/g, '-')),
          stats: {
            parish: { mw1: 0, mw3: 0, change: 0 },
            leaders: { mw1: 0, mw3: 0, change: 0 },
            parishioners: { mw1: 0, mw3: 0, change: 0 }
          }
        }));
      }

      return [
        "Experience of the Holy Spirit",
        "Asking & Discerning in Faith",
        "Responding in Faith"
      ].map(section => ({
        name: handleTranslate(section, section.toLowerCase().replace(/\s+/g, '-')),
        stats: {
          parish: { mw1: 0, mw3: 0, change: 0 },
          leaders: { mw1: 0, mw3: 0, change: 0 },
          parishioners: { mw1: 0, mw3: 0, change: 0 }
        }
      }));
    };

    if (!parishInsights || parishInsights.length < 2) {
      return {
        0: {
          title: handleTranslate("Holy Spirit", "holy-spirit"),
          icon: holySpiritIcon,
          mainCategory: handleTranslate("Holy Spirit", "holy-spirit"),
          subCategories: defaultSubCategories("Holy Spirit"),
          overall: {
            parish: { mw1: 0, mw3: 0, change: 0 },
            leaders: { mw1: 0, mw3: 0, change: 0 },
            parishioners: { mw1: 0, mw3: 0, change: 0 }
          }
        },
        1: {
          title: handleTranslate("Evangelization", "evangelization"),
          icon: evangelizationIcon,
          mainCategory: handleTranslate("Evangelization", "evangelization"),
          subCategories: defaultSubCategories("Evangelization"),
          overall: {
            parish: { mw1: 0, mw3: 0, change: 0 },
            leaders: { mw1: 0, mw3: 0, change: 0 },
            parishioners: { mw1: 0, mw3: 0, change: 0 }
          }
        },
        2: {
          title: handleTranslate("Leadership", "leadership"),
          icon: leadershipIcon,
          mainCategory: handleTranslate("Leadership", "leadership"),
          subCategories: defaultSubCategories("Leadership"),
          overall: {
            parish: { mw1: 0, mw3: 0, change: 0 },
            leaders: { mw1: 0, mw3: 0, change: 0 },
            parishioners: { mw1: 0, mw3: 0, change: 0 }
          }
        }
      };
    }

    const deployment1 = parishInsights[0];
    const deployment2 = parishInsights[1];

    const extractSectionData = (deployment, sectionName) => {
      const areas = deployment?.areasOfExcellence || [];
      const sectionObj = areas.find((area) => Object.keys(area)[0] === sectionName);
      if (!sectionObj || !Array.isArray(sectionObj[sectionName])) {
        return { totalAvg: 0, leaderAvg: 0, parishAvg: 0 };
      }
      const questions = sectionObj[sectionName][0]?.questions || [];
      if (!questions.length) {
        return { totalAvg: 0, leaderAvg: 0, parishAvg: 0 };
      }

      let totalSum = 0;
      let leaderSum = 0;
      let parishSum = 0;
      let validCount = 0;

      questions.forEach((question) => {
        totalSum += Number(question.totalAverage) || 0;
        leaderSum += Number(question.leaderAverage) || 0;
        parishSum += Number(question.parishionerAverage) || 0;
        validCount++;
      });

      const divisor = validCount || 1;
      return {
        totalAvg: Math.round(totalSum / divisor),
        leaderAvg: Math.round(leaderSum / divisor),
        parishAvg: Math.round(parishSum / divisor)
      };
    };

    const calculateChange = (oldValue = 0, newValue = 0) => {
      return Math.round(Math.abs((newValue || 0) - (oldValue || 0)));
    };

    const buildStats = (value1 = 0, value2 = 0) => ({
      mw1: Math.round(value1 || 0),
      mw3: Math.round(value2 || 0),
      change: calculateChange(value1, value2)
    });

    const holySpiritSections = [
      "Experience of the Holy Spirit",
      "Asking & Discerning in Faith",
      "Responding in Faith"
    ];
    const evangelizationSections = [
      "Resources Aligned",
      "Primacy of Programs",
      "Cultural Reinforcement"
    ];
    const leadershipSections = [
      "Vision",
      "Planning and Priorities",
      "Leading out of a team",
      "Growing Leadership Skills"
    ];

    const processCategory = (sections, categoryName, icon) => {
      const subCategories = sections.map((sectionName) => {
        const data1 = extractSectionData(deployment1, sectionName);
        const data2 = extractSectionData(deployment2, sectionName);

        return {
          name: handleTranslate(sectionName, sectionName.toLowerCase().replace(/\s+/g, '-')),
          stats: {
            parish: buildStats(data1.totalAvg, data2.totalAvg),
            leaders: buildStats(data1.leaderAvg, data2.leaderAvg),
            parishioners: buildStats(data1.parishAvg, data2.parishAvg)
          }
        };
      });

      const aggregateAudience = (audienceKey) => {
        if (!subCategories.length) {
          return { mw1: 0, mw3: 0, change: 0 };
        }
        const avgMw1 = subCategories.reduce((sum, cat) => sum + (cat.stats[audienceKey]?.mw1 || 0), 0) / subCategories.length;
        const avgMw3 = subCategories.reduce((sum, cat) => sum + (cat.stats[audienceKey]?.mw3 || 0), 0) / subCategories.length;
        return buildStats(avgMw1, avgMw3);
      };

      return {
        title: handleTranslate(categoryName, categoryName.toLowerCase().replace(/\s+/g, '-')),
        icon,
        mainCategory: handleTranslate(categoryName, categoryName.toLowerCase().replace(/\s+/g, '-')),
        subCategories,
        overall: {
          parish: aggregateAudience('parish'),
          leaders: aggregateAudience('leaders'),
          parishioners: aggregateAudience('parishioners')
        }
      };
    };

    return {
      0: processCategory(holySpiritSections, "Holy Spirit", holySpiritIcon),
      1: processCategory(evangelizationSections, "Evangelization", evangelizationIcon),
      2: processCategory(leadershipSections, "Leadership", leadershipIcon)
    };
  }, [parishInsights, langCtx.language]);

  const emptyStats = { mw1: 0, mw3: 0, change: 0 };
  const getStatsForAudience = (statsObj) => statsObj?.[activeAudience] || emptyStats;

  const audienceTabs = useMemo(() => ([
    { key: 'parish', label: handleTranslate("My Parish", "my-parish") },
    { key: 'leaders', label: handleTranslate("Leadership", "leadership") },
    { key: 'parishioners', label: handleTranslate("Parishioners", "parishioners") }
  ]), [langCtx.language]);

  const LoadingSpinner = () => (
    <div className="loading-container">
      <div className="spinner">
        <div className="spinner-inner"></div>
      </div>
      <p className="loading-text">{handleTranslate("Loading assessment data...", "loading-assessment-data")}</p>
    </div>
  );

  const getProgressBarColor = (complete) => {
    let color = '#87976E';
    if (complete <= 66) {
      color = '#84161D';
    } else if (complete <= 84) {
      color = '#DFB047';
    }
    return color;
  };

  const ProgressBar = ({ value, color }) => (
    <div className="progress-bar-container">
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${value}%`, backgroundColor: color }} />
      </div>
    </div>
  )

  const renderChangeCell = (oldValue = 0, newValue = 0, changeValue = 0) => {
    const delta = Math.round((newValue ?? 0) - (oldValue ?? 0));
    const arrowIcon = delta >= 0 ? grow : down;
    const displayValue = typeof changeValue === 'number' ? changeValue : Math.round(Math.abs(delta));

    return (
      <div className="change-cell" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: 700 }}>
        {displayValue}%
        <img src={arrowIcon} alt={delta >= 0 ? 'increase' : 'decrease'} style={{ width: '16px', height: '16px' }} />
      </div>
    );
  };

  const currentData = tabData[activeTab] || {}

  if (is404Error) {
    return (<Page404 />)
  }

  return (
    <div className="dashboard-multi-overview">
      <div className="overview-board">
        <div className="overview-header">
          {audienceTabs.map((tab) => (
            <button key={tab.key} type="button" className={`over-tab ${activeAudience === tab.key ? 'active' : ''}`} onClick={() => setActiveAudience(tab.key)}>
              {tab.label}
            </button>
          ))}
        </div>
        <div>
          <div className="boxes">
            <p className='subtext'>{preventWidow(handleTranslate("See how your parish compares between any two assessments.", "see-compare-heading-info"))}</p>
            {(!isLoadingDeploymentInfo && Array.isArray(deployments) && deployments.length === 0) ? (
              <ZeroState route="Overview" />
            ) : (
              <>
                <AssessmentDetails />
                {isLoadingParishInsights ? (
                  <LoadingSpinner />
                ) : (
                  parishInsights ? !(parishInsights?.[0]?.userCount === 0 || parishInsights?.[1]?.userCount === 0) ? (
                    <div className="dashboard-multi-assessment-overview">
                      <div className="overview-card">
                        <div className="tabs-container">
                          {Object.values(tabData).map((tab, index) => (
                            <div key={index} className={`tab ${activeTab === index ? 'active' : ''}`} onClick={() => setActiveTab(index)}>
                              <img src={tab.icon} alt={tab.title} className="tab-icon" />
                              <span className="tab-text">{tab.title}</span>
                            </div>
                          ))}
                        </div>

                        <div className='list-container'>
                          <div className="content-container">
                            <div className="main-icon">
                              <img src={currentData.icon} alt={currentData.title} />
                            </div>

                            <div className="data-table">
                              <div className="table-header">
                                <div className="header-cell">
                                  <img src={currentData.icon} alt={currentData.title} className="header-icon" />
                                </div>
                                <div className="header-cell">{parishInsights?.[0]?.deploymentTitle}</div>
                                <div className="header-cell cell-two">{parishInsights?.[1]?.deploymentTitle}</div>
                                <div className="header-cell cell-three">{handleTranslate("% Change", "percent-change")}</div>
                              </div>

                              {(() => {
                                const overallStats = getStatsForAudience(currentData.overall);
                                return (
                                  <div className="data-row main-category">
                                    <div className="category-name">{currentData.mainCategory}</div>
                                    <div className="progress-cell">
                                      <ProgressBar value={overallStats.mw1} color={getProgressBarColor(overallStats.mw1)} />
                                    </div>
                                    <div className="progress-cell">
                                      <ProgressBar value={overallStats.mw3} color={getProgressBarColor(overallStats.mw3)} />
                                    </div>
                                    {renderChangeCell(overallStats.mw1, overallStats.mw3, overallStats.change)}
                                  </div>
                                );
                              })()}

                              {currentData.subCategories?.map((subCategory, index) => {
                                const subStats = getStatsForAudience(subCategory.stats);
                                return (
                                  <div key={index} className="data-row sub-category">
                                    <div className="category-name">{formatLeadingOutOfATeam(subCategory.name)}</div>
                                    <div className="progress-cell">
                                      <ProgressBar value={subStats.mw1} color={getProgressBarColor(subStats.mw1)} />
                                    </div>
                                    <div className="progress-cell">
                                      <ProgressBar value={subStats.mw3} color={getProgressBarColor(subStats.mw3)} />
                                    </div>
                                    {renderChangeCell(subStats.mw1, subStats.mw3, subStats.change)}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  ) : (
                    <div className="no-data-container">
                      <p className="no-data-text">{handleTranslate("No data available", "no-data-available")}</p>
                    </div>
                  ) : <></>
                )}
              </>
            )}
          </div>

        </div>

      </div>


    </div>
  )
}

export default DashboardMultiAssessmentOverview